import script from "./VueDataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./VueDataTable.vue?vue&type=script&setup=true&lang=js"

import "./VueDataTable.vue?vue&type=style&index=0&id=564e7516&scoped=true&lang=css"
import "./VueDataTable.vue?vue&type=style&index=1&id=564e7516&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-564e7516"]])

export default __exports__